<template>
    <div>
        <h3 class="color_Azul family-01" v-if="(form.TipoTema == 'IMAGEN' && form.Titulo != '')" >{{form.Titulo}}</h3> 
        <hr v-show="(form.TipoTema == 'IMAGEN' && form.Titulo !='')" class="divider-02 hr-sm-left-0 bg-color">  
        <h5  v-show="(form.TipoTema == 'IMAGEN' && form.Subtitulo !='')" class="color_Azul">{{form.Subtitulo}}</h5>

        <div  v-if="(form.TipoTema == 'IMAGEN')">
            <div class="row justify-content-center" v-for="(detalle,key3) in form.detContenidoTema" :key="key3" >
                <img :src="RutaFile+detalle.Archivo" class="img-fluid mb-3" alt="ENES">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['value','RutaFile','listIconos','Tipo','index'],
    data() {
        return {
            form:this.value
        }
    },methods: {
        
    },
}
</script>